import { Col, Row, Typography } from 'antd'

interface IMetrics{
  firstTitle?: string
  secondTitle?: string
  firstValue?: number
  secondValue?: number
}
const { Title } = Typography
export const Metrics = ({ firstTitle = '', secondTitle = '', firstValue = 0, secondValue = 0 }: IMetrics): JSX.Element => {
  return (
    <Col span={14}>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} style={{ borderBottom: 'solid 1px', marginBottom: '20px' }}>
        <Col span={12}><Title level={5} style={{ fontSize: '15px', textAlign: 'center' }}>{firstTitle}</Title></Col>
        <Col span={12}><Title level={5} style={{ fontSize: '15px', textAlign: 'center' }}>{secondTitle}</Title></Col>
      </Row>
      <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} align="middle">
        <Col span={12}><Title level={4} style={{ fontFamily: 'PP Neue Machina', textAlign: 'center' }}>{firstValue}</Title></Col>
        <Col span={12}><Title level={5} style={{ fontFamily: 'PP Neue Machina', textAlign: 'center' }}>{secondValue === Infinity ? '∞' : secondValue}</Title></Col>
      </Row>
    </Col>
  )
}
